module.exports = __webpack_public_path__ + "img/face-grimace.44de8632.svg";